require('./style.scss');
import EventEmitter from '../../helpers/EventEmmiter';

export default class TransparentCanvas extends EventEmitter{
    _class = 'transparent-canvas';
    _node = null;
    _canvas = null;
    _video = null;
    _listenerLoadedmetadata = null
    _listenerPlay = null

    constructor(wrapper, video) {
        super();

        this._wrapper = wrapper;
        this._video = video;
        
        this._init();
    }

    _init() {
        const node = document.createElement('div');
        node.classList.add(this._class);
        node.append(this._createCanvas());

        this._node = node;
        this._wrapper.append(this._node);

        this._listenerLoadedmetadata = () => {
            this._canvas.width = this._video.videoWidth / 2;
            this._canvas.height = this._video.videoHeight / 2;
        }

        this._listenerPlay =  () => {
            requestAnimationFrame(this.processVideo.bind(this));
        }

        this._addListener();
    }

    _addListener(){
        this._video.addEventListener('loadedmetadata', this._listenerLoadedmetadata );
        this._video.addEventListener('play', this._listenerPlay);
    }

    _removeListener(){
        this._video.removeEventListener('loadedmetadata', this._listenerLoadedmetadata );
        this._video.removeEventListener('play', this._listenerPlay);
    }

    _createCanvas() {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        this._canvas = canvas;
        this._ctx = ctx;

        return canvas;
    }

    processVideo() {
        if (this._video.paused || this._video.ended) {
            return;
        }

        this.removeChromaKey();
        requestAnimationFrame(this.processVideo.bind(this));
    }

    removeChromaKey() {
        this._ctx.drawImage(this._video, 0, 0, this._canvas.width, this._canvas.height);
        const imageData = this._ctx.getImageData(0, 0, this._canvas.width, this._canvas.height);
        const data = imageData.data;
        for (let i = 0; i < data.length; i += 4) {
            const red = data[i];
            const green = data[i + 1];
            const blue = data[i + 2];
            if (green > red && green > blue) {
            data[i + 3] = 0;
            }
        }
        this._ctx.putImageData(imageData, 0, 0);
    }

    show = async () => {
        if(!this._wrapper.contains(this._node)) this._wrapper.appendChild(this._node);
    }

    hide(){
        if(this._wrapper.contains(this._node)) this._wrapper.removeChild(this._node);
    }

    applyClass(className){
        this._node.classList.add(className);
    }

    destroy(){
        this._removeListener();
        if(this._node && this._node.parentNode === this._wrapper) this._wrapper.removeChild(this._node);
    }
}


